import { defaultFiltersValue } from 'Components/collaboration/milestone/Filters'
import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { CampaignActivity } from 'types/campaign/activity'
import { encodeBase64 } from 'utils/helpers'

const CampaignCard: React.FC<{ campaign: CampaignActivity, filters: any }> = ({ campaign, filters }) => {

    const getFiltersQuery = (data: any) => {
        const encodedData = encodeBase64({ ...defaultFiltersValue, ...data, ...(filters.hub_id ? { hub_id: filters.hub_id, hub: filters.hub } : {}) });
        return `?filters=${encodedData}`;
    }


    const getAssigneeSteps = (campaign: CampaignActivity, assignee: string) => {
        const steps = campaign.steps ?? {};

        let assigneeStep: Record<string, { name: string, count: number, assignee: string }> = {};

        for (let [slug, step] of Object.entries(steps)) {
            if (step.assignee === assignee.toLowerCase()) {
                assigneeStep[slug] = step;
            }
        }

        return assigneeStep;

    }


    return (
        <div className='campaign-activity-card'>
            <div className="campaign-activity-card-header d-flex align-items-center justify-content-between">
                <div className="d-flex flex-column gap-1">
                    <h6 className="campaign-activity-card-header-title mb-0">{campaign.name} <Link target='_blank' to={{ pathname: '/tasks', search: getFiltersQuery({ campaign_id: campaign.id }) }}>
                        ({campaign.ongoing_collaborations_count ?? 0})
                    </Link>
                    </h6>
                    <span className="campaign-activity-card-header-subtitle">{campaign.brand?.name}</span>
                </div>

            </div>
            <div className="campaign-activity-card-body">
                <div className="d-flex flex-column gap-2">
                    <strong>Pending Steps</strong>
                    <div className="row g-2">
                        {
                            ['Influencer', 'Agency', 'Hub'].map((assignee, assigneeIndex) => (
                                <div className="col-12 col-md-6 col-lg-4 d-flex flex-column" key={assigneeIndex}>
                                    <div className="assignee-card flex-fill">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className='pending-step-assignee m-0'>
                                                <Link style={{all: 'unset', cursor: 'pointer'}} target='_blank' to={{ pathname: '/tasks', search: getFiltersQuery({ campaign_id: campaign.id, assignee: assignee.toLowerCase() }) }}>
                                                    By {assignee}
                                                    <span className=""><span> ({campaign.assignee_steps?.[assignee.toLowerCase() as 'influencer' | 'agency' | 'hub'] ?? 0})</span></span>
                                                </Link>
                                            </h6>

                                        </div>
                                        {
                                            Object.values(getAssigneeSteps(campaign, assignee)).length > 0 ? (
                                                <Row className='h-100'>
                                                    <Col xxl={12}>
                                                        {
                                                            <div className="row g-2">
                                                                {(Object.entries(getAssigneeSteps(campaign, assignee))).map(([slug, step], index: number) => (
                                                                    <div className='col-6 col-lg-6' key={index}>
                                                                        <div className="assignee-pending-step-card flex-fill h-100" key={index}>
                                                                            <h5>{step.name}</h5>
                                                                            <Link className='count' target='_blank' to={{ pathname: '/tasks', search: getFiltersQuery({ campaign_id: campaign.id, gig_step: slug }) }}>
                                                                                <h4 className="m-0"><span className="counter-value" data-target={step.count}>
                                                                                    {step.count}
                                                                                </span>
                                                                                </h4>
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        }

                                                    </Col>
                                                </Row>
                                            )
                                                : (
                                                    <div className="d-flex h-100 align-items-center justify-content-center w-100">
                                                        <span className='text-muted'>No Pending Steps</span>
                                                    </div>
                                                )
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CampaignCard